namespace Roodik.Game
{
	import Point = PIXI.Point;

	export class CheckBoxButton extends SimpleButton
	{
		private _on:boolean = true;

		constructor(container: any, private _marker: string,
		            markerInit:boolean,
		            text?: string,
		            fontStyle?: PIXI.TextStyleOptions,
		            anchor?:Point)
		{
			super(container,text,fontStyle,false,anchor);
			
			this._on = markerInit;
			this.updateMarker();
		}

		protected onUp(): void
		{
			super.onUp();

			this.on = !this._on;
		}

		private updateMarker()
		{
			this._container.armature.getSlot(this._marker).visible = this._on;
		}

		public set on(value:boolean)
		{
			this._on = value;
			this.updateMarker();
		}
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Core/Controls/CheckBoxButton.ts